import template from './project-expiration-report.html';
import controller from './project-expiration-report.controller';

let projectExpirationReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default projectExpirationReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/project-expiration-report/project-expiration-report.component.js